import {getTodayStartTime, daysBetween} from 'shared/utils/dateTime';
import {spentWithinPeriod} from 'core/History';
import {todayPeriod} from 'core/Period';

export function createPayload({budget, history}: AppState): UserSpentMoneyEventPayload {
  const today = getTodayStartTime();

  const initialBudget = budget.initial;
  const initialPeriod = daysBetween(budget.finishDate, budget.startDate);

  const spentAtLastDay = spentWithinPeriod(history, todayPeriod());
  const daysLeft = daysBetween(budget.finishDate, today);

  return {daysLeft, initialPeriod, initialBudget, spentAtLastDay};
}
